import React from 'react'

function CheckRectIcon() {
  return (
    <span className='anticon anticon-checkround'>
      <svg
        width='16'
        height='17'
        viewBox='0 0 16 17'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_dd_11396_242427)'>
          <rect x='1' y='1' width='14' height='14' rx='4' fill='#53C3BD' />
          <path
            d='M4.28125 7.78125L6.90625 10.4062L11.7188 5.59375'
            stroke='white'
            stroke-width='2'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </g>
        <defs>
          <filter
            id='filter0_dd_11396_242427'
            x='0'
            y='0'
            width='16'
            height='17'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feMorphology
              radius='1'
              operator='dilate'
              in='SourceAlpha'
              result='effect1_dropShadow_11396_242427'
            />
            <feOffset />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.32549 0 0 0 0 0.764706 0 0 0 0 0.741176 0 0 0 1 0'
            />
            <feBlend
              mode='normal'
              in2='BackgroundImageFix'
              result='effect1_dropShadow_11396_242427'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='1' />
            <feGaussianBlur stdDeviation='0.5' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0'
            />
            <feBlend
              mode='normal'
              in2='effect1_dropShadow_11396_242427'
              result='effect2_dropShadow_11396_242427'
            />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='effect2_dropShadow_11396_242427'
              result='shape'
            />
          </filter>
        </defs>
      </svg>
    </span>
  )
}

export default CheckRectIcon
